import {BadgeType} from "../interfaces";

export const getMappedStockColor = (color: string | undefined) => {
  // Convert stock color to Badge Type
  let stockColor: BadgeType = "neutral";
  switch (color) {
    case "green":
      stockColor = "success";
      break;
    case "orange":
      stockColor = "warning";
      break;
    case "red":
      stockColor = "neutral";
      break;
  }

  return stockColor;
}